import { Table } from 'antd';
import moment from 'moment';
import { applicationUrl, capitalize, capitalizeFirstLetter, formatMoney } from '../../../utils';
import useFetch from '../../../custom_hooks/useFetch';
import { useEffect } from 'react';
import TableLoading from '../../../components/TableLoading';
import { statusColor } from '../../../data';

const columns = [
    {
        title: 'Date',
        dataIndex: 'withDrawCreatedDate',
        render: (item) => <span>{moment(item).format('Do MMM YYYY')}</span>,
    },
    {
        title: 'Amount',
        dataIndex: 'withDrawAmount',
        render: (item) => <span>{formatMoney(item, 'KES')}</span>,
    },
    {
        title: 'Particulars',
        dataIndex: 'withDrawParticular',
        render: (item) => <span>{capitalizeFirstLetter(item)}</span>,
    },
    {
        title: 'Recipient number',
        dataIndex: 'withDrawMpesaNumber',
    },
    {

        title: 'Source account',
        dataIndex: 'withDrawCwCollection',
    },
    {
        title: 'Status',
        dataIndex: 'withDrawStatus',
        render: (status) => {
            const statusBackgroundColor = statusColor.find(({ label }) => label.toUpperCase() === status.toUpperCase())?.value || '#F6F6F6';

            return (
                <div
                    style={{
                        background: statusBackgroundColor,
                    }}
                    className="flex flex-shrink-0 w-full min-h-[1.8rem] h-auto items-center justify-center gap-[.5rem] px-[.5rem] py-[.25rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="4" viewBox="0 0 5 4" fill="none">
                        <circle cx="2.66602" cy="2" r="2" fill="#212121" />
                    </svg>
                    <span className="w-full truncate">{capitalize(status=== 'PENDING_OTP_VALIDATION' ? 'Cancelled' : status.split('_').join(' '))}</span>
                </div>
            );
        },
    },
];

export default function MpesaWithdrawalsTable() {
    const { isLoading, data } = useFetch(`${applicationUrl().url}/api/withdrawals/dynamic-withdraws?withDrawCategory=SETTLEMENT&withDrawType=MPESA`);

    useEffect(() => {}, [data]);

    if (isLoading) return <TableLoading />;

    return (
        <>
            <Table
                scroll={{
                    x: 1200,
                }}
                rowKey="withDrawId"
                className="mt-[1.5rem] !w-full"
                pagination={false}
                columns={columns}
                dataSource={data}
            />
        </>
    );
}
